import styled from 'styled-components';

export const Container = styled('div')(() => ({
  height: '90%',
  display: 'flex',
}));

export const HeaderBox = styled('div')(() => ({
  borderBottom: 'solid 1px #F5F5F5',
  background: '#F8F8F8',
  display: 'flex',
  justifyContent: 'space-between',
  height: '30px',
  padding: '0.3rem',
}));

export const HeaderBoxCenter = styled('div')(() => ({
  borderBottom: 'solid 1px #F5F5F5',
  background: '#F8F8F8',
  display: 'flex',
  justifyContent: 'center',
  height: '30px',
  padding: '0.3rem',
}));

export const StoryBodyBox = styled.div`
  padding-top: 0.5rem;
  width: 100%;
  height: 100%;
  max-width: 1024px;
  max-height: 1024px;
  margin: auto;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: auto;
    display: block;
  }
`;
